module.exports = __webpack_public_path__ + "img/fondoNY6.6d29dfe8.jpg";